




















































import {
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import _, { Dictionary } from "lodash";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import { formatCurrency } from "@/shared/currency";
import { AdvisoryFund } from "@/shared/types";
import * as RouteNames from "@/employee/route-names";
import InstrumentName from "./InstrumentName.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import CuratedRtqInstrumentsPieChart from "@/employee/components/investments/drivewealth/CuratedRtqInstrumentsPieChart.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useUserStore } from "@/shared/store/user";

const UncategorizedAssetCategory = "no_cat";

@Component({
  components: {
    InstrumentName,
    GenericLoadingSpinner,
    CuratedRtqInstrumentsPieChart
  }
})
export default class AdvisoryFunds extends mixins(ErrorsMixin) {
  formatCurrency = formatCurrency;
  RouteNames = RouteNames;
  funds: AdvisoryFund[] = [];

  drivewealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();
  custodianSettingsStore = useCustodianSettingsStore();
  userStore = useUserStore();


  @Prop({ required: false }) username: string;
  @Prop({ required: false }) partnerId: number;
  @Prop({ required: false }) accountId: number;
  @Prop({ required: false }) isCuratedRtqAccountType: boolean;

  @Watch("$props", { deep: true })
  onPropertyChange () {
    this.drivewealthStore.loadAdvisoryFunds({ username: this.username, partnerId: this.partnerId, force: true });
  }

  mounted (): void {
    this.drivewealthStore.loadAdvisoryFunds({ username: this.username, partnerId: this.partnerId, force: true });
    this.userStore.loadPartnerSettings();
  }

  get displayRtqInfo (): boolean {
    return this.isCuratedRtqAccountType;
  }

  get isLoaded (): boolean {
    return this.drivewealthStore.advisoryFundsLoaded;
  }

  fundFields = [
    {
      key: "instrument",
      thClass: "text-left pl-2 col-md-5",
      tdClass: "pl-2 col-md-5",
      label: "Investment"
    },
    {
      key: "fund_type",
      label: "Fund Type",
      thClass: "text-center col-md-2",
      tdClass: "text-center col-md-2"
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-center col-md-1",
      tdClass: "text-center col-md-1 text-capitalize"
    },
    {
      key: "shares",
      label: "Shares",
      thClass: "text-right col-md-1",
      tdClass: "text-right col-md-1"
    },
    {
      key: "balance",
      label: "Balance",
      thClass: "text-right col-md-1",
      tdClass: "text-right col-md-1"
    },
    {
      key: "action",
      label: "",
      thClass: "text-center col-md-2",
      tdClass: "col-md-2"
    }
  ];

  get fundItems () {
    if (!this.drivewealthStore.advisoryFunds) {
      return [];
    }

    return this.drivewealthStore.advisoryFunds.map(f => ({
      instrument: { symbol: f.stockSymbol, companyName: f.company, website: f.website, imageUrl: f.imageUrl },
      status: f.status,
      fund_type: this.drivewealthStore.fundTypeDisplayCopy(f.fundType),
      isEtfOrEquity: this.drivewealthStore.isFundEtfOrEquity(f.fundType),
      balance: f.balance === null ? "" : formatCurrency(f.balance),
      shares: f.sharesOwned === null ? "" : f.sharesOwned.toFixed(3),
      action: { symbol: f.stockSymbol },
      assetCategoryName: f.assetCategoryName,
      allocationPercentage: f.allocationPercentage,
    }));
  }

  routeParams (symbol: string): { symbol: string, accountId?: number } {
    if (this.accountId) {
      return { symbol, accountId: this.accountId };
    }

    return { symbol };
  }

  get groupedInstrumentDetails (): Dictionary<any[]> {
    const orderedResult = _.orderBy(this.fundItems, "allocationPercentage", "desc");
    const groupedResult = _.groupBy(orderedResult, item => {
      return _.get(item, "assetCategoryName", UncategorizedAssetCategory);
    });

    return groupedResult;
  }

  getInstrumentListAssetCategory (instrumentList: any[]): string {
      if (!instrumentList || !instrumentList.length) {
        return "";
      }

      const instrument = _.head(instrumentList);

      return instrument.assetCategoryName;
    }

  getInstrumentListHeading (instrumentList: any[]): string {
    if (!instrumentList || !instrumentList.length) {
      return "";
    }

    const instrument = _.head(instrumentList);

    if (!instrument.assetCategoryName && !instrument.allocationPercentage) {
      return "";
    }

    return `${instrument.assetCategoryName} - ${instrument.allocationPercentage}%`;
  }

  isInstrumentListOtherCategory (instrumentList: any[]): boolean {
    if (!instrumentList || !instrumentList.length) {
      return false;
    }

    const instrument = _.head(instrumentList);

    if (instrument.assetCategoryName && instrument.allocationPercentage === 0) {
      return true;
    }

    return false;
  }

  get buyRoute (): string {
    return RouteNames.DrivewealthBuyInstrumentV2;
  }


  get canBuy () {
    return !this.username && !this.userStore.partnerDisableInvestmentActivity;
  }
}
